import { isSameDay } from 'date-fns';
import { Mastercode } from 'types/schema-generated-types';

export interface MastercodeExpirationDate {
  code: string;
  date: Date;
}

const isSingleExpirationDate = (expirationDates: MastercodeExpirationDate[] = []): boolean => {
  if (!expirationDates.length) return false;

  return (
    expirationDates.length === 1 ||
    expirationDates.every(({ date }) => isSameDay(date, expirationDates[0].date))
  );
};

const getExpirationDates = (mastercodes: Mastercode[] = []): MastercodeExpirationDate[] => {
  const expirationDates: MastercodeExpirationDate[] = [];

  // For our purposes here, assume all order items in a mastercode have the same license type/expiration
  for (const mastercode of mastercodes) {
    const expirationDate = mastercode.orderItems?.[0]?.dateExpiration;
    if (expirationDate) {
      expirationDates.push({ code: mastercode.code, date: new Date(expirationDate) });
    }
  }

  return expirationDates;
};

export { isSingleExpirationDate, getExpirationDates };
